import React from "react";
import { Link, useLocation } from "react-router-dom";
// import "../BinTransfer/BinTransferMain.css"; 
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ps-0">
      {vPathName === "/priceenquiry" ? (
        <div>
          <span
            className="breadcrumb-not-active "
             style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Price Enquiry{" "}
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
